export const PROVIDER = 'provider';
export const MANAGER = 'manager';

export const GROUP_TYPE_TYPES = [
  { label: 'Care Option', value: PROVIDER },
  { label: 'Manager', value: MANAGER },
];

export const GROUP_TYPE_CATEGORY_OPTIONS = [{ label: 'All', value: 'All' }, ...GROUP_TYPE_TYPES];

export const MANAGER_CONFIG_FIELDS = [
  { label: 'Can receive escalations', value: 'canReceiveEscalations' },
  { label: 'Physician Team is required', value: 'patientPhysicianTeamRequired' },
  { label: 'Transferred From is required', value: 'patientTransferredFromRequired' },
];

export const PROVIDER_CONFIG_FIELDS = [
  { label: 'Designates contracted health plans for referrals', value: 'designatesAcceptedPlans' },
  { label: 'Hide discharged against medical advice (AMA) checkbox', value: 'hideDischargedAma' },
  { label: 'Hide discharge summary prompt', value: 'hideDischargeSummaryPrompt' },
];
